import React, { useMemo, useEffect, useState } from 'react'
import { Wrapper, AvatarProfile } from '../_components'
import Axios from 'axios'
// import Theme from '../Theme'
import { Stepper, Step, StepLabel } from '@material-ui/core'
// import Table from '../_components/Table'
import { formatCurrency } from '../_utils'

const steps = [
    // "Land Preparation",
    // "Planting",
    // "Crop Management",
    // "Pre-Harvesting",
    // "Harvesting",
    // "Post-Harvesting",
    // "Marketing/Selling"
]

// const NameField = record => {
//     return (
//         <div className="flex flex-col items-start justify-center">
//             <AvatarProfile bold label={`${record.value}`}/>
//         </div>
//     )
// }

export default function EditProductionForm() {

    const [ records, setRecords ] = useState( {
        LandRecords: [],
        PlantingResults: [],
        CropResults: [],
        PreHarvestResults: [],
        HarvestResults: [],
        PostHarvestResults: [],
        MarketingResults: []
    } )
    const [ total, setTotals ] = useState( [] )
    const [ loading, setLoading ] = useState( true )
    const [ activeStep, setActiveStep ] = useState( 0 )
    const isLastStep = activeStep ===( steps.length - 1 )
    

  useEffect( () => {
    if( loading ) {
     fetchProductionData()
    }
  }, [ loading ])

  const fetchProductionData = async () => {
    try {
        const response = await Axios.get( `https://mis.nec.go.ug/api/auth/productionData/${localStorage.getItem( "recordId" )}` )
        if( response.data ) {
            
            let LandResults = response.data.records.filter( item => {
                return item.phase ===  "land_preparation"
            } )
            let PlantingResults = response.data.records.filter( item => {
                return item.phase ===  "planting"
            } )
            let CropResults = response.data.records.filter( item => {
                return item.phase ===  "crop_management"
            } )
            let PreHarvestResults = response.data.records.filter( item => {
                return item.phase ===  "preharvesting"
            } )
            let HarvestResults = response.data.records.filter( item => {
                return item.phase ===  "harvesting"
            } )
            let PostHarvestResults = response.data.records.filter( item => {
                return item.phase ===  "post_harvesting"
            } )
            let MarketingResults = response.data.records.filter( item => {
                return item.phase ===  "marketing"
            } )

            let totals = response.data.records.filter( item => {
                return item.phase !== "marketing"
            } ).map( val => {
                return { 
                    quantity: parseFloat( val.quantity ) || 0,
                    rate: parseFloat( val.rate ) || 0
                }
            } ).map( value => {
                return value.quantity * value.rate
            } )

            
            
            //update the state
            setRecords( {
                LandRecords: LandResults,
                PlantingResults,
                CropResults,
                PreHarvestResults,
                HarvestResults,
                PostHarvestResults,
                MarketingResults
            } )
            setTotals( totals )
            setLoading( false )
        }
    } catch (error) {}
  }

  const handleNext = () => {
    if( isLastStep ) {
        setActiveStep( 0 )
    } else {
        setActiveStep( activeStep + 1 )
    }
  }

  if( loading ) {
    return (
        <Wrapper>
            {`Loading`}
        </Wrapper>
    )
  }
  
 let sales = records.MarketingResults
 let expenditure = total.reduce( ( prev, curr ) => prev + curr  )
 let profits = 0
 let revenue = 0

//  console.log( records )
//  let totals = records.filter( item => item.phase !== "marketing" ).map( val => {
//     return ( parseFloat( val.quantity ) || 0 ) * ( parseFloat( val.rate ) || 0 )
//  } )
//  console.log( totals )


  return (
    <Wrapper>
        {/* <div onClick={async () => {
            await localStorage.setItem( "name", "ProductionForm" )
            await localStorage.setItem( "tag", "edit" )
            return window.location.reload()

        }} className="cursor-pointer rounded-sm w-20 p-2 py-1 text-white bg-blue-500 text-sm flex items-center justify-center my-2">
            {`Edit`}
        </div> */}
        <div className="w-full h-5 bg-gray-700 text-white px-5 py-3 flex items-center">
            {`${localStorage.getItem("farmerName")} - ${localStorage.getItem("selectedFarmerCode")} - on Plot ${localStorage.getItem( "selectedPlotNo" )}`}
        </div>
        <div className="w-full grid md:flex lg:flex">
            <SummaryItemCard label="Total Revenue" figure={revenue} color={`red`} />
            <SummaryItemCard label="Total Profits" figure={profits} color={`green`}/>
            <SummaryItemCard label="Total Expenditure" color={`blue`} figure={formatCurrency( expenditure )}/>
            <SummaryItemCard label="Total Sales" color={`orange`} figure={formatCurrency( sales[ sales.length - 1  ]?.quantity * sales[ sales.length - 1  ]?.rate )}/>
        </div>
        <Stepper activeStep={activeStep}>
            {steps.map( label => {
            return (
                <Step key={label}>
                    <StepLabel>{label}</StepLabel>
                </Step>
            )
            } )}
        </Stepper>
        <div>
            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Land Preparation`}
                </h2>
                <LandList records={records?.LandRecords}/>
            </div>

            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Planting`}
                </h2>
                <LandList records={records?.PlantingResults}/>
            </div>

            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Crop Management`}
                </h2>
                <LandList records={records?.CropResults}/>
            </div>

            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Pre-Harvesting`}
                </h2>
                <LandList records={records?.PreHarvestResults}/>
            </div>

            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Harvesting`}
                </h2>
                <LandList records={records?.HarvestResults}/>
            </div>

            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Post Harvesting`}
                </h2>
                <LandList records={records?.PostHarvestResults}/>
            </div>

            <div className="flex flex-col items-start justify-center">
                <h2 className="text-base font-bold uppercase border-b border-gray-700">
                    {`Marketing`}
                </h2>
                <LandList records={records?.MarketingResults}/>
            </div>
        </div>

        <div className="flex hidden">
            <button onClick={() => setActiveStep( activeStep - 1 )} type="button" className="rounded mx-2 bg-green-500 px-3 py-2 text-white text-xs">
                {`Back`}
            </button>
            <button onClick={handleNext} type="button" className="mx-2 rounded bg-red-500 px-3 py-2 text-white text-xs">
                {isLastStep ? `Return` : `Next`}
            </button>
        </div>
    </Wrapper>
  )
}

const renderContent = ( step, records  ) => {
    switch( step ) {
        case 0:
            return <LandList records={records?.LandRecords} />
        case 1:
            return <LandList records={records?.PlantingResults}/>
        case 2:
            return <LandList records={records?.CropResults}/>
        case 3:
            return <LandList records={records?.PreHarvestResults}/>
        case 4:
            return <LandList records={records?.HarvestResults}/>
        case 5:
            return <LandList records={records?.PostHarvestResults}/>
        case 6:
            return <LandList records={records?.MarketingResults}/>
        default:
            break;
    }
}

const LandList = ( items ) => {
    let totalQty = items.records.map( val => parseFloat( val.quantity ) || 0 )?.reduce( ( total, currentVal ) => {
        return total + currentVal
    } )

    let totalAmount  = items.records.map( val => parseFloat( val.amount ) || 0 )?.reduce( ( total, currentVal ) => {
        return total + currentVal
    } )

    return (
        <div className="flex items-center justify-center">
            <table className="my-2 bg-white rounded">
                <thead className="text-sm font-bold py-2 bg-gray-200">
                    {/* <th className="px-2 text-center">
                        {`Season`}
                    </th> */}
                    <th className="px-2 text-center">
                        {`Phase`}
                    </th>
                    <th className="px-2 text-center">
                        {`Category of Inputs`}
                    </th>
                    <th className="px-2 text-center">
                        {`Labour Description`}
                    </th>
                    <th className="px-2 text-center">
                        {`Level of Measurement`}
                    </th>
                    <th className="px-2 text-center">
                        {`Qty ( man days )`}
                    </th>
                    <th className="px-2 text-center">
                        {`Rate`}
                    </th>
                    <th className="px-2 text-center">
                        {`Amount( UGX )`}
                    </th>
                </thead>
                <tbody>
                    {items.records.map( ( record, index ) => {
                        return (
                            <tr key={record.id} className="text-xs">
                                {/* <td className="px-2 py-2 text-center">{record.season}</td> */}
                                <td className="px-2 py-2 text-center font-bold">{record.phase?.toUpperCase()}</td>
                                <td className="px-2 py-2 text-center">{record.inputs}</td>
                                <td className="px-2 py-2 text-center">{record.labour}</td>
                                <td className="px-2 py-2 text-center">{record.measurement}</td>
                                <td className="px-2 py-2 text-center">{record.quantity}</td>
                                <td className="px-2 py-2 text-center">{record.rate}</td>
                                <td className="px-2 py-2 text-center">{record.amount}</td>
                            </tr>
                        )
                    } )}
                </tbody>
                <tfoot className="border-t border-gray-500">
                    <tr className="text-green-700">
                        <td className="p-2 font-bold text-xs"></td>
                        <td className="p-2 font-bold text-xs"></td>
                        <td className="p-2 font-bold text-xs"></td>
                        <td className="p-2 font-bold text-xs"></td>
                        <td className="p-2 font-bold text-xs text-center">
                        {`Total Inputs`}
                        </td>
                        <td className="p-2 font-bold text-xs text-center">
                            {totalQty}
                        </td>
                        <td className="p-2 font-bold text-xs text-center">
                            {``}
                        </td>
                        <td className="p-2 font-bold text-xs text-center">
                            {`${formatCurrency( totalAmount )}`}
                        </td>
                    </tr>
                </tfoot>
            </table>
        </div>
    )
}

const SummaryItemCard = ( { label = "Total Revenue", color, figure } ) => {
    return (
        <div className="w-36 border text-white flex flex-col items-center justify-center border rounded px-2 my-2 mx-2" style={{ backgroundColor: color }}>
            <div className="text-xs md:text-base lg:text-base text-white font-bold">
                {label}
            </div>
            <div className="text-base font-bold">
                {figure}
            </div>
        </div>
    )
}
